import { useQuery } from 'convex/react';
import { api } from '../../convex/_generated/api';
import type { Id } from '../../convex/_generated/dataModel';
import { useConvexMutation } from './use-convex-mutation';

export function useTodos() {
  const data = useQuery(api.todos.list, {});
  return { data, isLoading: data === undefined };
}

export function useAddTodo() {
  const { mutateAsync, isPending } = useConvexMutation(api.todos.add);
  return { mutateAsync: (text: string) => mutateAsync({ text }), isPending };
}

export function useToggleTodo() {
  const { mutateAsync, isPending } = useConvexMutation(api.todos.toggle);
  return { mutateAsync: (id: Id<'todos'>) => mutateAsync({ id }), isPending };
}

export function useRemoveTodo() {
  const { mutateAsync, isPending } = useConvexMutation(api.todos.remove);
  return { mutateAsync: (id: Id<'todos'>) => mutateAsync({ id }), isPending };
}
